import FeatureLayout from "app/components/features-layout";
import { Outlet } from "react-router";
import Layout from "app/components/layout";

export default function FeaturesPage() {
  return (
    <Layout headerIsOnTop={false} enableHeaderShrinkingOnScroll={false}>
      <FeatureLayout>
        <Outlet />
      </FeatureLayout>
    </Layout>
  );
}
